import React from 'react';
import { Clock, Bot, TrendingDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ProblemSection = () => {
  const { t } = useTranslation();
  const problems = [
    { icon: Clock, titleKey: 'problem.cards.timeLost.title', descKey: 'problem.cards.timeLost.desc', color: '#F59E0B' },
    { icon: Bot, titleKey: 'problem.cards.aiIgnores.title', descKey: 'problem.cards.aiIgnores.desc', color: '#8B5CF6' },
    { icon: TrendingDown, titleKey: 'problem.cards.invisibleTraffic.title', descKey: 'problem.cards.invisibleTraffic.desc', color: '#EF4444' },
  ];

  return (
    <section className="py-24 px-6 relative" data-testid="problem-section">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] to-[#050505]" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F59E0B]/20 to-transparent" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12 animate-fade-up">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F59E0B]/10 border border-[#F59E0B]/20 mb-6">
            <span className="text-sm text-[#fbbf24]">{t('problem.badge')}</span>
          </div>

          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-medium tracking-tight mb-6">
            {t('problem.title1')}
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#EF4444]">
              {t('problem.title2')}
            </span>
          </h2>

          <p className="text-base text-[#A1A1AA] max-w-3xl mx-auto leading-relaxed">{t('problem.body1')}</p>
          <p className="text-base text-[#A1A1AA] max-w-3xl mx-auto leading-relaxed mt-4">{t('problem.body2')}</p>
          <p className="text-base text-white/80 max-w-3xl mx-auto leading-relaxed mt-4 font-medium">{t('problem.body3')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 animate-fade-up" style={{ animationDelay: '0.2s' }}>
          {problems.map((p, i) => (
            <div key={i} className="text-center p-6 rounded-2xl bg-[#111111] border border-white/5 hover:border-white/10 transition-colors">
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: `${p.color}15` }}
              >
                <p.icon className="w-7 h-7" style={{ color: p.color }} strokeWidth={1.5} />
              </div>
              <h3 className="font-['Outfit'] text-lg font-medium mb-2">{t(p.titleKey)}</h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed">{t(p.descKey)}</p>
            </div>
          ))}
        </div>

        <div className="text-center animate-fade-up" style={{ animationDelay: '0.3s' }}>
          <p className="text-sm text-[#0055FF] font-medium">{t('problem.transition')}</p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
